import React from 'react';
import { Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Reusable component for section headers
 * Reduces repetition across all gallery components
 */
const SectionHeader = ({
  title,
  subtitle,
  description,
  textColor = 'black',
}) => (
  <Container>
    <h1 className="project-heading">{title}</h1>
    {subtitle && <h2 className="project-subtitle">{subtitle}</h2>}
    {description && <p style={{ color: textColor, textAlign: 'left' }}>{description}</p>}
    <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
  </Container>
);

SectionHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  textColor: PropTypes.string,
};

export default SectionHeader;
